// removed by extract-text-webpack-plugin
module.exports = {"LargeDestinationCardWrapper":"src-components-LargeDestinationCard-__LargeDestinationCard-module___LargeDestinationCardWrapper","LargeDestinationCardImage":"src-components-LargeDestinationCard-__LargeDestinationCard-module___LargeDestinationCardImage","LargeDestinationCardLocation":"src-components-LargeDestinationCard-__LargeDestinationCard-module___LargeDestinationCardLocation","LargeDestinationCardPrice":"src-components-LargeDestinationCard-__LargeDestinationCard-module___LargeDestinationCardPrice"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeDestinationCard/LargeDestinationCard.module.css
// module id = 1025
// module chunks = 0